import type { JSX } from 'react';
import { PrismicRichText } from '@prismicio/react';
import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';

export type TwitterCardProps = SliceComponentProps<Content.TwitterCardSlice>;

const TwitterCard = ({ slice }: TwitterCardProps): JSX.Element => (
  <section>
    <span className="title">
      {slice.primary.title ? (
        <PrismicRichText field={slice.primary.title as any} />
      ) : (
        <h2>Template slice, update me!</h2>
      )}
    </span>
    {slice.primary.description ? (
      <PrismicRichText field={slice.primary.description as any} />
    ) : (
      <p>start by editing this slice from inside Slice Machine!</p>
    )}
    <style>{`
      section {
        max-width: 600px;
        margin: 4em auto;
        text-align: center;
      }
      .title {
        color: #8592e0;
      }
    `}</style>
  </section>
);

export default TwitterCard;
